import { deleteObj, openAs, OpenMode, getCurrentSpaceId } from "../core";
import type { DrawingModuleType } from "../DrawingSingleton";
import type { DrawingModule } from "../types/DrawingWeb";
import { applyTextHeightToMText, applyTextStyleToMText } from "../database";
import type { Textstyle } from "@/types";

/** OdDbMText attachment point values (insertion point position relative to text box). */
export type MTextAttachment = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
export const MTextAttachment = {
  kTopLeft: 1,
  kTopCenter: 2,
  kTopRight: 3,
  kMiddleLeft: 4,
  kMiddleCenter: 5,
  kMiddleRight: 6,
  kBottomLeft: 7,
  kBottomCenter: 8,
  kBottomRight: 9,
} as const satisfies Record<string, MTextAttachment>;

export function createTextAtPosition(
  module: DrawingModuleType,
  db: DrawingModule.OdDbDatabase,
  worldX: number,
  worldY: number,
  text: string,
  textstyle: Textstyle,
  height?: number,
  attachment: MTextAttachment = MTextAttachment.kTopLeft,
) {
  const mtext = module.OdDbMText.createObject();
  mtext.setDatabaseDefaults(db, true);

  const currentSpaceId = getCurrentSpaceId(db);
  const currentSpace = openAs(
    currentSpaceId,
    module.OdDbBlockTableRecord,
    OpenMode.kForWrite,
  );
  const entityId = currentSpace.appendOdDbEntity(mtext);

  const location = new module.OdGePoint3d(worldX, worldY, 0);
  mtext.setLocation(location);
  mtext.setAttachment(attachment);

  const content = text;
  const textStr = new module.OdString(content);
  mtext.setContents(textStr);

  applyTextStyleToMText(module, db, mtext, textstyle);

  if (height) {
    applyTextHeightToMText(mtext, height);
  }

  deleteObj(currentSpace);
  deleteObj(mtext);
  deleteObj(textStr);
  deleteObj(location);

  return entityId;
}
